/**
 * Where an article template draws the end-of-article conversation (`ArticleConversation`):
 * right AFTER SoundGuys' "Have your say" poll sets (`nc-have-your-say`) when the content has
 * them — article → Have your say → Conversation (Guillaume, 2026-10-27); before that, right
 * above "You might like" (`nc-recommend`), which is off on SoundGuys since the same day; otherwise
 * -1 = after the tags, at the end of the content. Android Authority maps neither block, so on AA
 * this always returns -1 in practice.
 *
 * The template draws the conversation right after the block at the returned index.
 */
export const CONVERSATION_AFTER_RESOURCE = 'nc-have-your-say'

export function conversationSlot(blocks: ReadonlyArray<{ resource: string }>): number {
  return blocks.findIndex(b => b.resource === CONVERSATION_AFTER_RESOURCE)
}
